<template>
  <div class="box" v-if="employee">
    <card-section-switch
      :switchItems="switchItems"
      :selected="'Grafik'"
      @cardChanged="handleCardChange"
    />
    <template v-if="selectedCard === 'Grafik'">
      <employee-schedule :employeeId="employee.id" />
    </template>
    <template v-if="selectedCard === 'Zadania'">
      <employee-tasks :employeeId="employee.id" />
    </template>
    <template v-if="selectedCard === 'Umowa/rachunki'">
      <employee-attachments
        :employeeId="employee.id"
        :firstName="employee.firstName"
        :lastName="employee.lastName"
      />
    </template>
  </div>
</template>

<script>
import CardSectionSwitch from "./CardSectionSwitch.vue";
import EmployeeAttachments from "./EmployeeAttachments.vue";
import EmployeeSchedule from "./EmployeeSchedule.vue";
import EmployeeTasks from "./EmployeeTasks.vue";
export default {
  components: {
    CardSectionSwitch,
    EmployeeSchedule,
    EmployeeTasks,
    EmployeeAttachments,
  },
  mounted() {
    this.$store.dispatch("getDodTasksCategories");
    this.$store.dispatch("getDodTasksPriorities");
    this.$store.dispatch("getDodUsers", {
      search: "",
    });
    this.$store.dispatch("getDodAdmins");
    if (this.panelCan("showBills")) {
      this.$store.dispatch("getEmployeeBills", {
        employeeId: this.employee.id,
      });
    }
  },
  name: "EmployeeManagement",
  props: ["employee"],
  data: () => {
    return {
      switchItems: ["Grafik", "Zadania", "Umowa/rachunki"],
      selectedCard: "Grafik",
    };
  },
  methods: {
    handleCardChange(card) {
      this.selectedCard = card;
    },
  },
};
</script>

<style scoped>
.box {
  padding: 1rem 0 0 0;
  border-radius: 8px;
  border: 0.5px solid rgba(9, 7, 65, 0.25);
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
}
</style>